import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BacchusDrinks from '../../assets/home/baccchus-drinks-logo-footer.svg'
import DesktopMenu from '../../common/DesktopMenu/index';
import MobileMenu from '../../common/MobileMenu/index';
import useWindowSize from '../../common/windowSize';
import NewFooter from '../../common/NewFooter';
import Button from '../../common/SmallButton';
import {
    SuccessfulDiv,
    SuccessfulP,
} from './styles';
import {
    Background,
} from '../Login/styles';
import { useTranslation } from "react-i18next";

const SuccessfulRegistration = () => {
    const size = useWindowSize()
    const navigate = useNavigate()
    const [mobileMenu, setMobileMenu] = useState(false)
    const { t } = useTranslation();

    useEffect(() => {
      if (size.width < 1200) {
        setMobileMenu(true);
      } else {
        setMobileMenu(false);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [size]);

    return(
        <>
            {mobileMenu ? <MobileMenu single={true}/> : <DesktopMenu single={true}/> }
            <Background>
                <SuccessfulDiv>
                    <img src={BacchusDrinks} alt={"Company logo"} style={{width: '70%', marginBottom: '15px'}} />
                    <SuccessfulP>{t("yourRegistrationRequest")}</SuccessfulP>
                    <Button function={() => navigate('/')} name="Home page"/>
                </SuccessfulDiv>
            </Background>
            <NewFooter/>
        </>
    )
}
export default SuccessfulRegistration;
